import $ from 'jquery';
import mCustomScrollbar from 'malihu-custom-scrollbar-plugin';
import jqueryMousewheel from 'jquery-mousewheel';

function customScrollbar() {
	var $customScrollbar = $('.js-custom-scroll');
	if ($(window).width() >= 768) {
		$customScrollbar.mCustomScrollbar();
	}
}

export default customScrollbar;



// WEBPACK FOOTER //
// ./app/blocks/custom-scrollbar/custom-scrollbar.js